var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStat01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 219.06451612903038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}.cls-1,.cls-2,.cls-3{fill:none;}.cls-2{stroke:#e8ba3a;}.cls-2,.cls-3{stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}.cls-4{clip-path:url(#clippath);}.cls-3{stroke:#193c34;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.709677419350555,
    y: 8.129032258066218,
    width: 234.5806451612989,
    height: 203.2258064516136
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 166.12199703532815,
    cy: 147.06941139340051,
    r: 29.98427541800697
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 166.1242403448923,
    cy: 147.06941028379697,
    r: 10.791496187460325
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 166.1242403448923,
    y1: 136.27791409633573,
    x2: 166.1242403448923,
    y2: 132.53956633008966
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 163.82782671705354,
    y1: 132.53956633008966,
    x2: 168.42065397272927,
    y2: 132.53956633008966
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 173.88569150526928,
    y1: 139.5716595644899,
    x2: 176.57438296234795,
    y2: 136.97431817952202
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 174.97887325443298,
    y1: 135.32269342731342,
    x2: 178.16989267026293,
    y2: 138.6259429317197
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 176.91573653235537,
    y1: 147.0694102838097,
    x2: 180.65408429860145,
    y2: 147.0694102838188
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 180.65408429860145,
    y1: 144.77299665597275,
    x2: 180.65408429859235,
    y2: 149.36582391165757
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 173.765206371947,
    y1: 154.68991080130763,
    x2: 176.4121598418733,
    y2: 157.32977468972786
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 178.03379051619777,
    y1: 155.70378898677882,
    x2: 174.790529167567,
    y2: 158.95576039269508
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 166.12415466722086,
    y1: 157.86090647091623,
    x2: 166.1241249871,
    y2: 161.599254237055
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 168.42053861486602,
    y1: 161.5992724691223,
    x2: 163.8277113593358,
    y2: 161.59923600497677
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 158.60502980474848,
    y1: 154.81007322807636,
    x2: 156.0002543928549,
    y2: 157.49156331289487
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 157.64745544495418,
    y1: 159.09163963735227,
    x2: 154.35305334074474,
    y2: 155.89148698844838
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 155.33429648316087,
    y1: 147.2524442279573,
    x2: 151.5964864675043,
    y2: 147.315850128718
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 151.63543580654004,
    y1: 149.61193342405386,
    x2: 151.55753712846854,
    y2: 145.01976683338398
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 158.35715217693541,
    y1: 139.5774992221759,
    x2: 155.66650796982685,
    y2: 136.9821807885146
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 154.07224093199875,
    y1: 138.63500508717334,
    x2: 157.26077500763859,
    y2: 135.32935648985585
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m124.711918304285064,159.448918347739891s-10.506436407245928,7.45779267954822.000027448248147,18.621029520634693c0,0,10.895629108634239-9.380871295034012-.000027448248147-18.621029520634693Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m112.938108048567301,101.711052431546705s1.374053503097457,12.810771038515668,16.247374761735045,9.097557571167272c0,0-2.861846689502272-14.089901115788962-16.247374761735045-9.097557571167272Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m152.141794490120446,64.64613755391656s-7.545767165369398,10.443432171310633,5.995463581111835,17.629440060773049c0,0,7.295058954930937-12.3894146258408-5.995463581111835-17.629440060773049Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m115.941861837716715,172.467949499388851s-7.45779267954822-10.506436407236833-18.621029520632874.000027448248147c0,0,9.380871295023098,10.895629108643334,18.621029520632874-.000027448248147Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "134.773111226886613 114.373820214656007 147.531033912411658 114.373820214656007 149.713888596921606 117.385507618744668"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m129.654328644373891,116.90114060085034s3.410844194309902,12.424573212489122-11.789394879835527,14.413636209375909c0,0-2.494557394556978-14.159543189387477,11.789394879835527-14.413636209375909Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m93.705166645169811,105.999163880116612s3.152524038345291,12.492616612158599,17.360209272574139,6.735419394606652c0,0-4.804615404007563-13.551057181877695-17.360209272574139-6.735419394606652Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m74.366172853879107,115.507996478430869s6.926358380442252,10.864135364412505,18.598014766757842.925519931848612c0,0-8.827715421590256-11.34843250682934-18.598014766757842-.925519931848612Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m93.78625634394848,156.54486813427684s10.506436845023927-7.457792062808949-.000026355170121-18.621029520634693c0,0-10.895629659309634,9.380870655451872.000026355170121,18.621029520634693Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m112.381839726942417,118.701631836980596s5.115268117582673,11.825308017794669-9.657296184419465,15.921035481880608c0,0-4.450678746634367-13.671391246725761,9.657296184419465-15.921035481880608Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "159.743145907870712 87.992936961079977 169.554272025359751 98.254367933168396 169.434344289340515 113.336968219509799"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m152.141794490120446,64.64613755391656s-7.545767165369398,10.443432171310633,5.995463581111835,17.629440060773049c0,0,7.295058954930937-12.3894146258408-5.995463581111835-17.629440060773049Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m135.189277606570613,53.977771505366036s-6.574144894071651,11.080816600884646,7.559457615838255,17.017559782865646c0,0,6.149127113105351-12.996296229073778-7.559457615838255-17.017559782865646Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m114.294178832718899,48.07112703581879s-2.400027008830875,12.658741959121471,12.910975093724119,13.418251098351902c0,0,1.347105136312166-14.314355999440522-12.910975093724119-13.418251098351902Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m107.213248233583727,74.654238323884783s11.002006367791182,6.705201974113152,17.106085584577158-7.356940694486184c0,0-12.922395678522662-6.3029492981168-17.106085584577158,7.356940694486184Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m94.289940732443938,57.845191577298465s6.230386222941888,11.277684387472618,18.503176015296049,2.091702119378169c0,0-8.09757462583184-11.880436233825094-18.503176015296049-2.091702119378169Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m135.900222010885045,89.633561031134377s8.918015997660405,9.299078895030107,18.419678297126666-2.730969029382322c0,0-10.877379188881605-9.402026478805055-18.419678297126666,2.730969029382322Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m121.860094683364878,81.899434893017315s10.614844517482197,7.302667560566988,17.486335393310583-6.40084485997977c0,0-12.554520722447705-7.007102779090928-17.486335393310583,6.40084485997977Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m145.845143231297698,21.38555253488812c-50.783364605142197,0-91.951415684630774,41.168051079481302-91.951415684630774,91.951415684621679,0,50.783364605144016,41.168051079488578,91.951415684632593,91.951415684630774,91.951415684632593"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "138.893060093043459 16.258064516128798 145.845143231297698 21.38555253488812 139.799008264513759 27.092102897639052"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStat01);
export default __webpack_public_path__ + "static/media/stat01.87c499709f6effe71cefb7a9226561ea.svg";
export { ForwardRef as ReactComponent };